//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ProductLot',
  props: {
    lot: {
      type: Number,
      required: true
    },
    unitAmount: {
      type: String,
      required: true
    }
  },
  computed: {
    formattedLot() {
      return this.$t('lot', {
        x: this.lot,
        unit_amount: this.unitAmount
      });
    }

  }
};